import { CartTypeEnum } from "@lib/enum"
export class CartConfigModel {
  id: any
  uniqueId?: string
  approvalType?: number
  salesPolicies?: any[]
  type?: CartTypeEnum
  projectId?: number
  startShowCart?: string
  endShowCart?: string
  startBooking?: string
  endBooking?: string
  emailsAll?: string[]
  userIdsAll?: string[]
  agencyMasterNotificationTypeAll?: number
  constructor() {
    this.id = undefined
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new CartConfigModel(), obj)
    newObj.cartUserManagers = obj.cartUserManagers?.map((i) => ({
      ...i,
      value: i.id,
      label: i.name,
    }))
    newObj.emailsAll = obj.notifications[0]?.emails
    newObj.userIdsAll = obj.notifications[0]?.userIds
    newObj.agencyMasterNotificationTypeAll =
      obj.notifications[0]?.agencyMasterNotificationType
    return newObj
  }

  public static assigns(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}
